import React from 'react'
import { useTranslation } from 'react-i18next'
import Mockup from "../assets/mockup-2.png"

const AboutUsComponents = () => {
    const { t } = useTranslation();

    return (
        <div className='about-us-component-content'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-2">
                        <h4>{t('Hakkımızda')}</h4>
                    </div>
                    <div className="col-lg-6">
                        <h3 className='mb-4'>{t('Paragon Yatırım: Güvenli ve Kazançlı Yatırımın Adı')}</h3>
                        <p className="mb-2">
                            {t('Paragon Yatırım, forex piyasasında yüksek başarı oranları ve güvenli işlem altyapısı ile yatırımcılarına kazançlı fırsatlar sunan lider bir platformdur. Yenilikçi teknolojiler, profesyonel analizler ve kullanıcı dostu arayüzler ile her seviyeden yatırımcıya en iyi hizmeti vermeyi amaçlıyoruz. Hedefimiz, yatırımcılarımızın finansal başarılarını artırmak ve piyasada güçlü bir yer edinmelerini sağlamaktır. Paragon ile siz de güvenli, hızlı ve kârlı bir yatırım deneyimi yaşayabilirsiniz.')}
                        </p>
                        <p className="mb-0">
                            {t('Yatırımcılarımıza sadece teknik altyapı sunmakla kalmıyor, aynı zamanda kapsamlı eğitim içerikleri ve stratejik destek de sağlıyoruz. Paragon, sürekli olarak piyasa trendlerini analiz eder ve yatırımcılarının doğru adımları atmasına yardımcı olacak araçları sunar. Yatırımcıların hedeflerine ulaşırken doğru bilgiye sahip olmalarını sağlamak, bizim için öncelikli bir değerdir.')}
                        </p>
                    </div>
                    <div className="col-lg-4" style={{ backgroundImage: 'url("https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/bg-line-circle-digipay.png")', backgroundColor: "#D8F6EE", borderRadius: 10, backgroundPosition: "center", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 50 }}>
                        <img src={Mockup} alt="" width="175px" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUsComponents